"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.sort");

var _defineProperty2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/defineProperty"));

require("core-js/modules/web.dom.iterable");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _sortablejs = _interopRequireDefault(require("sortablejs"));

var _followBook = require("../../api/followBook");

var _menu = require("../../utils/menu");

var _index = _interopRequireDefault(require("../Form/OssAudio/index.vue"));

var _index2 = _interopRequireDefault(require("../Form/OssExcleCon/index.vue"));

var _qrcode = require("../../utils/qrcode");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = {
  name: 'BookMenuList',
  components: {
    OssAudio: _index.default,
    OssExclecom: _index2.default
  },
  data: function data() {
    return {
      downAllPNG: [],
      AllLists: [],
      IsuploadAudio: false,
      totalElements: '',
      dropType: '',
      currentChildData: [],
      dragStartIndex: '',
      dragEndIndex: '',
      draggingNode: '',
      dropNode: '',
      ispackUp: false,
      IseditCon: false,
      dialogTitle: '',
      classdialogTitle: '',
      menuDataObj: {},
      excleCon: '',
      addBookConForm: {
        resourceOpenId: '',
        followUpTypeId: 1,
        menuId: '',
        sentence: '',
        sentenceZhCn: '',
        phoneticSymbol: '',
        pronunciation: '',
        sequence: '',
        spokesman: '',
        spokesmanZhCn: '',
        scene: 'false',
        difficult: 'false',
        contentType: undefined
      },
      followOptions: [{
        followUpTypeId: 1,
        followUpTypeIdTitle: '单词'
      }, {
        followUpTypeId: 2,
        followUpTypeIdTitle: '会话'
      }],
      addBookConDialog: false,
      query: {
        page: 1,
        size: 10
      },
      tableData: [],
      isPost: '',
      loadingBtn: false,
      isappendPar: false,
      classificationData: {},
      // 点击保存的对象
      classificationDialog: false,
      addClassiFicationForm: {
        partentClassiFicationName: '',
        classiFicationName: '',
        followUpTypeId: 1,
        sequence: ''
      },
      body: {
        resourceOpenId: '',
        followUpTypeId: 1,
        parentId: '',
        title: '',
        sequence: ''
      },
      data: [],
      loading: {
        contentList: false,
        menuList: false
      },
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      bookData: {
        id: undefined,
        scene: undefined,
        bookMenuId: undefined,
        title: undefined
      },
      dialogVisible: false
    };
  },
  computed: {
    openId: function openId() {
      return this.$route.query.openId;
    },
    bookId: function bookId() {
      return this.$route.query.id;
    }
  },
  watch: {
    'addClassiFicationForm.followUpTypeId': {
      handler: function () {
        var _handler = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.getList();

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler() {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getList();

            case 2:
              if (!this.data.length) {
                _context2.next = 12;
                break;
              }

              this.$refs.selectTree.setCurrentKey(this.data[0].id);
              this.bookData.id = this.data[0].id;
              this.menuDataObj = this.data[0];
              _context2.next = 8;
              return this.updateList();

            case 8:
              document.body.ondrop = function (event) {
                event.preventDefault();
                event.stopPropagation();
              };

              this.rowDrop();
              _context2.next = 13;
              break;

            case 12:
              return _context2.abrupt("return", '');

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    /* 批量下载 */
    downAll: function downAll() {
      var _this2 = this;

      this.AllLists.forEach(function (item, index) {
        _this2.downAllPNG.push({
          bookMenuId: item.id,
          id: _this2.bookId,
          scence: undefined !== item.followUpTypeId ? item.followUpTypeId : undefined,
          title: item.title
        });

        (0, _qrcode.handleData)(_this2.downAllPNG[index]);
      });
      this.$confirm('是否批量下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(function () {
        _this2.AllLists.forEach(function (item, index) {
          (0, _qrcode.handleData)(_this2.downAllPNG[index]);
          (0, _qrcode.downLoadPNG)(_this2.downAllPNG[index], 1);
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消下载'
        });
      });
    },

    /* 判断文件是否正在上传 */
    uploadAudio: function uploadAudio(val) {
      this.IsuploadAudio = val;
    },

    /* 分页方法 每页多少条 */
    handleSizeChange: function handleSizeChange(val) {
      var vm = this;
      vm.query.size = val;
      vm.getAlllist();
    },

    /* 跳页方法 */
    handleCurrentChange: function handleCurrentChange(val) {
      var vm = this;
      vm.query.page = val;
      vm.getAlllist();
    },
    updateList: function () {
      var _updateList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading.menuList = true;
                _context3.prev = 1;
                _context3.next = 4;
                return this.getAlllist();

              case 4:
                _context3.next = 10;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](1);
                message = _context3.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 10:
                _context3.prev = 10;
                this.loading.menuList = false;
                return _context3.finish(10);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 6, 10, 13]]);
      }));

      function updateList() {
        return _updateList.apply(this, arguments);
      }

      return updateList;
    }(),

    /* 取消编辑菜单 */
    cancelEditclass: function cancelEditclass(formName) {
      this.classificationDialog = false;
      this.$refs[formName].resetFields();
      this.addClassiFicationForm.classiFicationName = '';
    },

    /* 根据openId，id删除图书内容 */
    deletedCon: function () {
      var _deletedCon = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return (0, _followBook.deleteBookCon)(this.openId, data.id);

              case 3:
                res = _context4.sent;

                if (res) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                this.$notify({
                  type: 'success',
                  message: '删除图书内容成功!',
                  title: '成功!'
                });
                this.updateList();
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                console.log(_context4.t0);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function deletedCon(_x) {
        return _deletedCon.apply(this, arguments);
      }

      return deletedCon;
    }(),

    /* 编辑右侧图书内容 */
    handleUpdate: function handleUpdate(data) {
      this.IseditCon = true;
      this.addBookConDialog = true;
      this.dialogTitle = '编辑图书';
      console.log(data);
      this.addBookConForm = _objectSpread({}, data);
    },

    /* 添加右侧图书内容 */
    addBookConDia: function addBookConDia() {
      if (this.menuDataObj.id && !this.menuDataObj.children) {
        this.addBookConForm = {};
        this.IseditCon = false;
        this.addBookConDialog = true;
        this.dialogTitle = '添加图书';
      } else {
        this.$notify.info({
          title: '提示',
          message: '请选择左侧子级目录'
        });
      }
    },

    /* 添加右侧图书内容 */
    addBookCon: function addBookCon(formName) {
      var _this3 = this;

      if (!this.addBookConForm.pronunciation) {
        this.$notify({
          type: 'warning',
          title: '警告!',
          message: '文件不能为空!'
        });
        return;
      }

      this.$refs[formName].validate( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this3.addBookConForm.resourceOpenId = _this3.menuDataObj.resourceOpenId;
                  _this3.addBookConForm.followUpTypeId = _this3.menuDataObj.followUpTypeId;
                  _this3.addBookConForm.menuId = _this3.menuDataObj.id;
                  _this3.addBookConForm.contentType = _this3.menuDataObj.followUpTypeId;

                  if (!valid) {
                    _context5.next = 28;
                    break;
                  }

                  _context5.prev = 5;
                  _this3.loadingBtn = true;

                  if (_this3.IseditCon) {
                    _context5.next = 13;
                    break;
                  }

                  console.log('this.addBookConForm', _this3.addBookConForm);
                  _context5.next = 11;
                  return (0, _followBook.addBookCon)(_this3.addBookConForm);

                case 11:
                  _context5.next = 15;
                  break;

                case 13:
                  _context5.next = 15;
                  return (0, _followBook.editBookCon)(_this3.openId, _this3.addBookConForm.id, _this3.addBookConForm);

                case 15:
                  _this3.updateList();

                  _this3.$notify({
                    type: 'success',
                    title: '成功!',
                    message: '保存图书内容成功!'
                  });

                  _context5.next = 22;
                  break;

                case 19:
                  _context5.prev = 19;
                  _context5.t0 = _context5["catch"](5);
                  console.log(_context5.t0);

                case 22:
                  _context5.prev = 22;
                  _this3.loadingBtn = false;
                  _this3.addBookConDialog = false;
                  return _context5.finish(22);

                case 26:
                  _context5.next = 30;
                  break;

                case 28:
                  console.log('error submit!!');
                  return _context5.abrupt("return", false);

                case 30:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[5, 19, 22, 26]]);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /* 刷新左侧菜单 */
    refresh: function refresh() {
      try {
        this.menuDataObj = [];
        this.updateList();
      } catch (e) {
        console.log(e);
      }
    },

    /* 展开收起 */
    packUp: function packUp() {
      this.ispackUp = !this.ispackUp;
      var treeList = this.data;

      for (var i = 0; i < treeList.length; i++) {
        this.$refs.selectTree.store.nodesMap[treeList[i].id].expanded = !this.$refs.selectTree.store.nodesMap[treeList[i].id].expanded;
      }
    },

    /* 左侧菜单列表 */
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$readMenuList, data, message;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                this.loading.list = true;
                _context6.next = 4;
                return (0, _followBook.readMenuList)(this.openId, this.addClassiFicationForm.followUpTypeId);

              case 4:
                _yield$readMenuList = _context6.sent;
                data = _yield$readMenuList.data;
                this.data = (0, _menu.formatList)(data);
                this.data.sort(function (a, b) {
                  return a.sequence - b.sequence;
                });
                this.AllLists = data;
                this.loading.list = false;
                _context6.next = 17;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);
                message = _context6.t0.message;
                this.loading.list = false;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 12]]);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }(),

    /* 添加父级菜单 */
    appendPar: function appendPar() {
      this.isappendPar = true;
      this.classdialogTitle = '添加菜单';
      this.classificationDialog = true;
      this.addClassiFicationForm.classiFicationName = '';
      this.addClassiFicationForm.partentClassiFicationName = '/';
      this.isPost = true;
    },

    /* 添加子级级菜单，修改 */
    append: function append(data, apiStr) {
      console.log(data);
      this.classdialogTitle = '添加子菜单';

      if (apiStr === 'post') {
        this.isPost = true;
        this.addClassiFicationForm.classiFicationName = '';
      } else {
        this.isPost = false;
        this.classdialogTitle = '编辑菜单';
        this.addClassiFicationForm.classiFicationName = data.title;
        this.addClassiFicationForm.sequence = data.sequence;
      }

      this.isappendPar = false;
      this.classificationDialog = true;
      this.classificationData = data;
      /* 获取父级title */

      if (!data.parentId) {
        this.addClassiFicationForm.partentClassiFicationName = '/';
      } else {
        this.getParents(this.data, data);
      }
    },

    /* 递归查询 */
    // eslint-disable-next-line consistent-return
    getParents: function getParents(data, arr) {
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (var i in data) {
        if (data[i].id === arr.parentId) {
          this.addClassiFicationForm.partentClassiFicationName = data[i].title;
        }

        if (data[i].children) {
          var ro = this.getParents(data[i].children, arr);
          if (ro !== undefined) return ro.concat(data[i].id);
        }
      }
    },
    addClassiFication: function addClassiFication(formName) {
      var _this4 = this;

      this.$refs[formName].validate( /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
          var res, _res;

          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (!valid) {
                    _context7.next = 39;
                    break;
                  }

                  _this4.body.resourceOpenId = _this4.openId;
                  _this4.body.followUpTypeId = _this4.addClassiFicationForm.followUpTypeId;
                  _this4.body.title = _this4.addClassiFicationForm.classiFicationName;
                  _this4.body.sequence = _this4.addClassiFicationForm.sequence;

                  if (_this4.isappendPar) {
                    _this4.body.parentId = '';
                  } else {
                    _this4.body.parentId = _this4.classificationData.id;
                  }

                  _context7.prev = 6;
                  _this4.loadingBtn = true;

                  if (!_this4.isPost) {
                    _context7.next = 18;
                    break;
                  }

                  console.log('执行添加接口');
                  _context7.next = 12;
                  return (0, _followBook.createMenu)(_this4.body);

                case 12:
                  res = _context7.sent;

                  if (res) {
                    _context7.next = 15;
                    break;
                  }

                  return _context7.abrupt("return");

                case 15:
                  _this4.$notify({
                    type: 'success',
                    title: '成功!',
                    message: '添加菜单成功!'
                  });

                  _context7.next = 25;
                  break;

                case 18:
                  console.log('执行修改接口'); // TODO

                  _context7.next = 21;
                  return (0, _followBook.updateMenu)(_this4.classificationData.id, {
                    title: _this4.addClassiFicationForm.classiFicationName,
                    sequence: _this4.addClassiFicationForm.sequence
                  });

                case 21:
                  _res = _context7.sent;

                  if (_res) {
                    _context7.next = 24;
                    break;
                  }

                  return _context7.abrupt("return");

                case 24:
                  _this4.$notify({
                    type: 'success',
                    title: '成功!',
                    message: '修改菜单成功!'
                  });

                case 25:
                  _this4.getList();

                  _context7.next = 31;
                  break;

                case 28:
                  _context7.prev = 28;
                  _context7.t0 = _context7["catch"](6);

                  _this4.$notify.error({
                    title: '错误',
                    e: _context7.t0
                  });

                case 31:
                  _context7.prev = 31;
                  _this4.classificationDialog = false;
                  _this4.loadingBtn = false;
                  _this4.addClassiFicationForm.classiFicationName = '';

                  _this4.$refs[formName].resetFields();

                  return _context7.finish(31);

                case 37:
                  _context7.next = 40;
                  break;

                case 39:
                  console.log('error submit!!');

                case 40:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, null, [[6, 28, 31, 37]]);
        }));

        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    remove: function remove(node, data) {
      var _this5 = this;

      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return (0, _followBook.deleteMenu)(data.id);

              case 3:
                res = _context8.sent;

                if (res) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt("return");

              case 6:
                _this5.$notify({
                  type: 'success',
                  title: '成功!',
                  message: '删除菜单成功!'
                });

                _this5.getList();

                _context8.next = 13;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](0);
                console.log(_context8.t0);

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 10]]);
      }))).catch(function () {});
    },
    // 二维码弹窗处理
    alertQRCode: function alertQRCode(node, data) {
      if (undefined === this.bookId) {
        this.$message.error('图书id不能为空，请重新点击图书进行查看');
      } else {
        this.dialogVisible = true;
        console.log(this.bookId);
        this.bookData.id = this.bookId;
        this.bookData.scene = undefined !== data.followUpTypeId ? data.followUpTypeId : undefined;
        this.bookData.bookMenuId = data.id;
        this.bookData.title = data.title;
      }
    },
    // 二维码弹窗打开后回调函数
    openDialog: function openDialog() {
      (0, _qrcode.makeQRCode)(this.bookData);
    },
    downLoadPNGClick: function downLoadPNGClick() {
      (0, _qrcode.downLoadPNG)(this.bookData, 1);
    },

    /* 点击节点 获取右侧列表 */
    renderBookList: function () {
      var _renderBookList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(data) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.menuDataObj = data;
                console.log('节点数据', data);
                this.getAlllist();

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function renderBookList(_x4) {
        return _renderBookList.apply(this, arguments);
      }

      return renderBookList;
    }(),

    /* 获取右侧列表所有内容 */
    getAlllist: function () {
      var _getAlllist = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var query, res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                if (!this.menuDataObj.id) {
                  this.menuDataObj.id = 0;
                }

                this.loading.contentList = true;
                this.tableData = [];
                query = {
                  page: this.query.page,
                  size: this.query.size
                };
                console.log('分页参数', query);
                _context10.next = 8;
                return (0, _followBook.resourceListContent)(this.openId, this.menuDataObj.id, this.query.page, this.query.size);

              case 8:
                res = _context10.sent;

                if (!res.data) {
                  this.tableData = [];
                }

                res.data.sort(function (a, b) {
                  return a.sequence - b.sequence;
                });
                this.tableData = res.data;
                console.log('this.tableData', this.tableData); // this.rowDrop();

                this.totalElements = res.totalElements;
                this.loading.contentList = false;
                _context10.next = 21;
                break;

              case 17:
                _context10.prev = 17;
                _context10.t0 = _context10["catch"](0);
                this.loading.contentList = false;
                console.log(_context10.t0.message);

              case 21:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 17]]);
      }));

      function getAlllist() {
        return _getAlllist.apply(this, arguments);
      }

      return getAlllist;
    }(),
    handleDragEnter: function handleDragEnter(draggingNode, dropNode, ev) {// console.log('tree drag enter: ', dropNode.label);
    },
    handleDragLeave: function handleDragLeave(draggingNode, dropNode, ev) {// console.log('tree drag leave: ', dropNode.label);
    },
    handleDragOver: function handleDragOver(draggingNode, dropNode, ev) {// console.log('tree drag over: ', dropNode.label);
    },
    handleDragStart: function handleDragStart(node) {
      this.draggingNode = node.data;

      if (this.draggingNode.parentId) {
        this.getParentId(this.data, this.draggingNode);
      } else {
        this.currentChildData = this.data;
      }

      for (var i = 0; i < this.currentChildData.length; i++) {
        if (this.currentChildData[i].id === this.draggingNode.id) {
          this.dragStartIndex = i;
          console.log('this.dragStartIndex', this.dragStartIndex);
        }
      }
    },
    // 行拖拽
    rowDrop: function rowDrop() {
      var tbody = document.querySelector('.el-table__body-wrapper tbody');

      var _this = this;

      _sortablejs.default.create(tbody, {
        onEnd: function () {
          var _onEnd = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref6) {
            var newIndex, oldIndex, i, _i, data, res;

            return regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    newIndex = _ref6.newIndex, oldIndex = _ref6.oldIndex;

                    if (newIndex > oldIndex) {
                      _this.tableData[oldIndex].sequence = _this.tableData[newIndex].sequence;

                      for (i = 0; i < _this.tableData.length; i++) {
                        if (oldIndex + 1 <= i && i <= newIndex) {
                          _this.tableData[i].sequence = _this.tableData[i].sequence - 1;
                        }
                      }
                    } else {
                      console.log(newIndex, oldIndex);
                      _this.tableData[oldIndex].sequence = _this.tableData[newIndex].sequence;

                      for (_i = 0; _i < _this.tableData.length; _i++) {
                        if (_i <= oldIndex - 1 && newIndex <= _i) {
                          console.log(_this.tableData[_i].sequence);
                          _this.tableData[_i].sequence = _this.tableData[_i].sequence + 1;
                        }
                      }
                    }

                    console.log('this.tableData', _this.tableData);
                    data = [];

                    _this.tableData.forEach(function (item) {
                      data.push({
                        id: item.id,
                        sequence: item.sequence
                      });
                    });

                    _context11.prev = 5;
                    _this.loading.contentList = true;
                    console.log('排序参数', data);
                    _context11.next = 10;
                    return (0, _followBook.uploadConSequence)(data);

                  case 10:
                    res = _context11.sent;

                    if (!res.data.success) {
                      _this.loading.contentList = false;

                      _this.$notify({
                        type: 'error',
                        title: '失败!',
                        message: '更新排序失败!'
                      });
                    } else {
                      _this.loading.contentList = false;

                      _this.getAlllist();
                    }

                    _context11.next = 18;
                    break;

                  case 14:
                    _context11.prev = 14;
                    _context11.t0 = _context11["catch"](5);
                    _this.loading.contentList = false;

                    _this.$notify({
                      type: 'error',
                      title: '更新排序失败!',
                      message: _context11.t0.message
                    });

                  case 18:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11, null, [[5, 14]]);
          }));

          function onEnd(_x5) {
            return _onEnd.apply(this, arguments);
          }

          return onEnd;
        }()
      });
    },
    handleDragEnd: function handleDragEnd(draggingNode, dropNode, dropType, ev) {
      for (var i = 0; i < this.currentChildData.length; i++) {
        if (this.currentChildData[i].id === draggingNode.data.id) {
          this.dragEndIndex = i;
          console.log('this.dragEndIndex', this.dragEndIndex);
        }
      }
    },
    handleDrop: function () {
      var _handleDrop = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(draggingNode, dropNode, dropType) {
        var i, _i2, data, res;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                console.log('拖动成功');

                if (this.dragStartIndex > this.dragEndIndex) {
                  this.currentChildData[this.dragEndIndex].sequence = this.currentChildData[this.dragEndIndex + 1].sequence;

                  for (i = 0; i < this.currentChildData.length; i++) {
                    console.log(dropType);

                    if (this.dragEndIndex + 1 <= i && i <= this.dragStartIndex) {
                      console.log(i);
                      this.currentChildData[i].sequence = this.currentChildData[i].sequence + 1;
                    }
                  }
                } else {
                  this.currentChildData[this.dragEndIndex].sequence = this.currentChildData[this.dragEndIndex - 1].sequence;

                  for (_i2 = 0; _i2 < this.currentChildData.length; _i2++) {
                    if (this.dragStartIndex <= _i2 && _i2 <= this.dragEndIndex - 1) {
                      this.currentChildData[_i2].sequence = this.currentChildData[_i2].sequence - 1;
                    }
                  }
                }

                console.log(this.currentChildData);
                data = [];
                this.currentChildData.forEach(function (item) {
                  data.push({
                    id: item.id,
                    sequence: item.sequence
                  });
                });
                console.log('data', data);
                _context12.prev = 6;
                this.loading.list = true;
                console.log('排序参数', data);
                _context12.next = 11;
                return (0, _followBook.uploadSequence)(data);

              case 11:
                res = _context12.sent;
                console.log(res);

                if (!res.data.success) {
                  this.loading.list = false;
                  this.$notify({
                    type: 'error',
                    title: '失败!',
                    message: '更新排序失败!'
                  });
                } else {
                  this.getList();
                }

                _context12.next = 20;
                break;

              case 16:
                _context12.prev = 16;
                _context12.t0 = _context12["catch"](6);
                this.loading.list = false;
                this.$notify({
                  type: 'error',
                  title: '更新排序失败!',
                  message: _context12.t0.message
                });

              case 20:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[6, 16]]);
      }));

      function handleDrop(_x6, _x7, _x8) {
        return _handleDrop.apply(this, arguments);
      }

      return handleDrop;
    }(),
    getParentId: function getParentId(data, arr) {
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (var i in data) {
        if (data[i].id === arr.parentId) {
          this.currentChildData = data[i].children;
        }

        if (data[i].children) {
          this.getParents(data[i].children, arr);
        }
      }
    },
    handleAfter: function handleAfter() {},

    /* 判断能否被放置 */
    allowDrop: function allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.parentId === draggingNode.data.parentId && type !== 'inner') {
        return true;
      }

      return false;
    },
    getNode: function getNode(node, data) {
      console.log(node, data);
    }
  }
};
exports.default = _default;